import {
    Article,
    DirectionsRun,
    LocalOffer,
    Newspaper,
    Psychology,
    QuestionMark,
    TipsAndUpdates,
    WorkHistory
} from "@mui/icons-material";

// eslint-disable-next-line import/prefer-default-export
export const getIcon = (type: string) => {
    switch (type.toLowerCase()) {
        case "page":
            return Article;
        case "article":
            return Newspaper;
        case "tip":
            return TipsAndUpdates;
        case "tag":
            return LocalOffer;
        case "run":
            return DirectionsRun;
        case "experience":
            return WorkHistory;
        case "project":
            return Psychology;
        default:
            return QuestionMark;
    }
};
